import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutList, CalendarDays } from 'lucide-react';
import { cn } from '../../lib/utils';
import Segmented from '../ui/segmented';

const MODES = [
  { key: 'list', to: '/app/tasks', label: 'tasks.views.list', icon: LayoutList },
  { key: 'calendar', to: '/app/planner', label: 'tasks.views.calendar', icon: CalendarDays },
];

/**
 * The top of Tasks: its title, the List | Calendar switch and the page's one action.
 * The Planner is the Calendar of Tasks (/app/planner), so both pages show this and the
 * switch moves between them (in place, so Back leaves Tasks). Phones have the title in
 * the top bar and the switch across the screen.
 */
export default function TasksHeader({ mode, title, meta, action, showSwitch = true }) {
  const { t } = useTranslation();
  return (
    <div className={cn('flex items-center gap-3 min-h-8', !showSwitch && 'max-md:hidden')}>
      <div className="hidden md:flex items-baseline gap-2 min-w-0">
        <h1 className="text-lg font-semibold text-foreground truncate">{title}</h1>
        {meta && <span className="text-xs text-muted-foreground flex-shrink-0 tabular-nums">{meta}</span>}
      </div>
      {showSwitch && (
        <Segmented label={title} value={mode} fill="phone" className="max-md:flex-1"
          items={MODES.map(({ key, to, label, icon }) => ({ key, to, icon, label: t(label), testId: `tasks-mode-${key}` }))} />
      )}
      {action && <div className="ml-auto flex items-center gap-2 flex-shrink-0">{action}</div>}
    </div>
  );
}
